import { configureStore } from '@reduxjs/toolkit';
import reportingReducer from '../features/reporting/reportingSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';
import scanLogsReducer from '../features/scanlogs/scanLogsSlice';
import auditLogReducer from '../features/auditLogs/auditLogSlice';
import mastheadReducer from '../features/masthead/mastheadSlice';
import schedulingReducer from '../features/scheduling/schedulingSlice';
import detectionStatusReducer from '../features/detections/detectionStatusSlice';
import detectionsReducer from '../features/detections/detectionSlice';
import policyEngineReducer from '../features/policyengine/policyEngineSlice';

export const store = configureStore({
	reducer: {
		reporting: reportingReducer,
		notifications: notificationsReducer,
		scanlogs: scanLogsReducer,
		auditLogs: auditLogReducer,
		masthead: mastheadReducer,
		scheduling: schedulingReducer,
		detectionStatus: detectionStatusReducer,
		detections: detectionsReducer,
		policyEngine: policyEngineReducer,
	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
